import type React from 'react'
import { createContext, useContext } from 'react'
import type { DialogOptions, MotionPreset, UseDialogReturn } from './types'

interface DialogContextValues
  extends DialogOptions,
    Omit<UseDialogReturn, 'motionPreset'> {
  motionPreset?: MotionPreset
}

export const DialogContext = createContext<DialogContextValues | null>(null)

export const DialogProvider =
  DialogContext.Provider as React.Provider<DialogContextValues>

export const useDialogContext = () => {
  const context = useContext(DialogContext)

  if (context === null) {
    throw new Error(
      'Attempted to call useDialogContext outside the Dialog component.'
    )
  }

  return context
}
